<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <page-header
          title="Coupons"
          :return_button="false"
          :action_button="true"
          action_button_text="New Coupon"
          action_button_link="/staff/coupons/add"
        ></page-header>
        <div class="row">
          <div class="col-md-12">
            <div v-if="!loading.page && coupons.length > 0">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Code</th>
                    <th scope="col">Name</th>
                    <th scope="col">Value</th>
                    <th scope="col">Current Usage</th>
                    <th scope="col">Max Usage</th>
                    <th scope="col">Status</th>
                    <th scope="col" class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="coupon in coupons" :key="coupon.id">
                    <th scope="row">{{ coupon.id }}</th>
                    <td class="fw-bolder">{{ coupon.code }}</td>
                    <td>{{ coupon.name }}</td>
                    <td>
                      <div v-if="coupon.type == 'amount'">
                        <span class="currency_code">GH₵</span>
                        <b> {{ coupon.value }}</b>
                        <span class="currency_code"> off.</span>
                      </div>
                      <div v-if="coupon.type == 'percentage'">
                        <b> {{ coupon.value }}</b>
                        <span class="currency_code"> % off.</span>
                      </div>
                    </td>
                    <td>{{ coupon.current_usage }}</td>
                    <td>{{ coupon.max_usage }}</td>
                    <td>{{ coupon.status_code }}</td>
                    <td class="text-end">
                      <a :href="`/staff/coupons/${coupon.id}/view`">
                        <i class="bi-pencil-square fs-5 text-primary me-2"></i>
                      </a>
                      <i class="bi-trash fs-5 text-danger"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <ul class="pagination justify-content-center mt-5">
                  <li v-if="pagination.currentPage > 1" class="page-item">
                    <a
                      class="page-link"
                      href="#"
                      aria-label="Previous"
                      @click.prevent="changePage(pagination.currentPage - 1)"
                    >
                      <span aria-hidden="true">«</span>
                    </a>
                  </li>
                  <li
                    class="page-item"
                    v-for="page in pagination.totalPages"
                    :key="page"
                    :class="{ active: page == pagination.currentPage }"
                  >
                    <a
                      v-if="
                        page < 3 ||
                        page > pagination.totalPages - 3 ||
                        (page < pagination.currentPage + 3 &&
                          page > pagination.currentPage - 3)
                      "
                      class="page-link"
                      @click.prevent="changePage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    v-if="pagination.currentPage < pagination.totalPages"
                    class="page-item"
                  >
                    <a
                      class="page-link"
                      aria-label="Next"
                      @click.prevent="changePage(pagination.currentPage + 1)"
                    >
                      <span aria-hidden="true">»</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <center-message v-else-if="coupons.length == 0"
              >No coupons found.</center-message
            >

            <loader v-if="loading.page"> </loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CenterMessage from "@/components/CenterMessage.vue";
import PageHeader from "@/components/layout/navigation/PageHeader.vue";
import Loader from "@/components/Loader.vue";
import CouponService from "@/services/staff/CouponService";

export default {
  name: "ListCouponsView",
  components: {
    PageHeader,
    Loader,
    CenterMessage,
  },

  data() {
    return {
      loading: {
        page: false,
      },
      coupons: [],
      pagination: {
        currentPage: 1,
        perPage: 12,
        totalRows: 0,
        totalPages: 0,
      },
    };
  },

  async mounted() {
    await this.getRecords();
    this.loading.page = false;
  },

  methods: {
    async getRecords(search) {
      this.loading.page = true;
      if (search === true) {
        this.pagination.currentPage = 1;
      }

      let response = await CouponService.getCoupons(
        this.pagination.currentPage,
        this.pagination.perPage
      );

      this.coupons = response.data.coupons.data;
      this.pagination.totalRows = response.data.coupons.total;
      this.loading.page = false;
      this.pagination.totalPages = response.data.coupons.last_page;
    },

    changePage(page) {
      if (this.pagination.currentPage != page) {
        this.pagination.currentPage = page;
        this.getRecords();
      }
    },
  },
};
</script>
